import {
  normalizeDiscountFixedLak,
  roundDiscountLakToThousand,
} from "@/modules/cf-feed/domain/lib/cf-session-pricing";
import { AppImage } from "@/shared/ui/AppImage";

/** คั่นหลักพันด้วยจุด — เช่น 15000 → 15.000 */
export function formatGroupedInteger(amount: number): string {
  if (!Number.isFinite(amount)) return "";
  const n = Math.round(amount);
  if (n < 0) return "";
  return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function formatKip(amount: number): string {
  return `${formatGroupedInteger(amount)} ກີບ`;
}

/** ตัวเลขสำหรับ input ราคา (คั่นหลักพันแบบ x.xxx.xxx; 0 ได้) */
export function formatPriceInput(amount: number): string {
  return formatGroupedInteger(amount);
}

/** แปลงค่าจาก input ที่มีคั่นหลัก / ກີບ กลับเป็นจำนวนเต็ม (>= 0) */
export function parsePriceInput(raw: string): number | null {
  const digits = raw.replace(/\D/g, "");
  if (digits === "") return null;
  const n = Number.parseInt(digits, 10);
  if (!Number.isFinite(n) || n < 0) return null;
  return n;
}

/** ส่วนลด LAK คงที่ — ปัดเป็นหลักพัน (x,000) ก่อนบันทึก */
export function parseDiscountFixedLakInput(raw: string): number | null {
  const parsed = parsePriceInput(raw);
  if (parsed == null) return null;
  return normalizeDiscountFixedLak(parsed);
}

/** blur/mask ส่วนลด LAK ให้แสดงเป็น x,000 */
export function maskDiscountFixedLakInput(raw: string): string {
  const parsed = parsePriceInput(raw);
  if (parsed == null) return "";
  const rounded = roundDiscountLakToThousand(parsed);
  if (rounded <= 0) return "";
  return formatPriceInput(rounded);
}

/** ขณะพิมพ์ — เก็บเฉพาะตัวเลขแล้ว format เป็น x.xxx.xxx */
export function maskPriceInput(raw: string): string {
  const parsed = parsePriceInput(raw);
  if (parsed == null) return "";
  return formatPriceInput(parsed);
}

export function Thumb({
  src,
  alt = "",
}: {
  src: string | null | undefined;
  alt?: string;
}) {
  return (
    <div className="size-10 overflow-hidden rounded border bg-muted">
      <AppImage
        src={src ?? null}
        alt={alt}
        className="size-full object-cover"
        fallback={
          <div className="flex size-full items-center justify-center text-muted-foreground text-xs">
            —
          </div>
        }
      />
    </div>
  );
}
